import getCalendarSharingCalendars from '../data/selectors/getCalendarSharingCalendars';
import getCalendarSharingCurrentState from '../data/selectors/getCalendarSharingCurrentState';
import getCalendarSharingInitialState from '../data/selectors/getCalendarSharingInitialState';
/**
 * Checks shared calendar options store for changes
 * @returns true if there are changes in the current state, false otherwise.
 */
export default function isSharedCalendarsOptionDirty() {
    var currentState = getCalendarSharingCurrentState();
    var initialState = getCalendarSharingInitialState();
    var calendars = getCalendarSharingCalendars();
    for (var i = 0; i < calendars.length; i++) {
        var folderId = calendars[i].folderId;
        if (initialState[folderId] != null &&
            currentState[folderId] != null &&
            initialState[folderId] !== currentState[folderId]) {
            return true;
        }
    }
    return false;
}
//# sourceMappingURL=isSharedCalendarsOptionDirty.js.map